require('./accountRetentions.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @  utilities
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const classNames = require('classnames');
// @ components
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { LoadingSection } = require('commonsComponents/loadingSection');
const AccountRetentionsTableRow = require('components/accounts/accountRetentions/accountRetentionsTableRow/accountRetentionsTableRow');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');

// @ language
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();

class AccountRetentions extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
    }

    componentDidMount() {
        this.props.requestAccountRetentions(this.props.accountId);
    }

    buildConectionError() {
        const lostConnectionFirstLine = formatText('myMoneyTransactions-lostConnectionFirstLine');
        const retryButton = (
            <OKButton onClick={this.handleRetry}>
                <FormattedText value="myMoneyTransactions-retry" />
            </OKButton>
        );

        return <EmptyState primaryText={lostConnectionFirstLine} button={retryButton} iconType="nointernet-banking"/>;
    }

    buildEmptyState() {
        let primaryText = formatText('accountsRetentions-noRetentions');
        return <EmptyState primaryText={primaryText} iconType="noitems-banking"/>;
    }

    handleNextPage() {
        const { accountId, requestNextAccountRetentionsPage } = this.props;
        requestNextAccountRetentionsPage(accountId);
    }

    handleRetry() {
        const accountId = this.props.accountId;

        this.props.requestAccountRetentions(accountId);
    }

    buildHeadersRow(){
        const { immScreen } = this.props;
        let headers;
        const additionalCCTableHeaders = __CONTACT_CENTER__ && this.buildCCtableHeaders()

        if (!immScreen.get('isMobile')) {
            headers = (
                <thead>
                    <OKTableRow asHeader>
                        <OKTableCell asHeader>
                            <WebappRender>
                                <FormattedText value="myMoneyTransactions-myMoneyTransactions_periodValidity" />
                            </WebappRender>
                            <ContactCenterRender>
                                <FormattedText value="myMoneyTransactions-validity" format="firstUppercase" />
                            </ContactCenterRender>
                        </OKTableCell>
                        <OKTableCell asHeader>
                            <FormattedText value="myMoneyTransactions-description" format="firstUppercase" />
                        </OKTableCell>
                        <ContactCenterRender>
                            {additionalCCTableHeaders.reasonHeader}
                            {additionalCCTableHeaders.startDateHeader}
                            {additionalCCTableHeaders.endDateHeader}
                        </ContactCenterRender>
                        <OKTableCell asHeader className="account-retentions__cell-header-import">
                            <FormattedText value="myMoneyTransactions-amount" format="firstUppercase"/>
                        </OKTableCell>
                    </OKTableRow>
                </thead>
            );
        }

        return headers;
    }

    buildCCtableHeaders() {
        const additionalCCHeaders = {}

        additionalCCHeaders.reasonHeader = (
            <OKTableCell asHeader={true}>
                <FormattedText
                    value="myMoneyTransactions-reason"
                    format="firstUpperCase"
                />
            </OKTableCell>
        );
        additionalCCHeaders.startDateHeader = (
            <OKTableCell asHeader={true}>
                <FormattedText
                    value="myMoneyTransactions-startDate"
                    format="firstUpperCase"
                />
            </OKTableCell>
        );
        additionalCCHeaders.endDateHeader = (
            <OKTableCell asHeader={true}>
                <FormattedText
                    value="myMoneyTransactions-endDate"
                    format="firstUpperCase"
                />
            </OKTableCell>
        );

        return additionalCCHeaders;
    }

    render() {
        const { immAccountsRetentions, accountId } = this.props;
        const immAccountRetentions = immAccountsRetentions.get(accountId);
        let innerContent;
        let hideComponent = false;

        if (immAccountRetentions) {
            const byOrderEmpty = immAccountRetentions.get('byOrder').size === 0;

            if (!!immAccountRetentions.get('loading')) {
                innerContent = <LoadingSection />;
            } else if (!!immAccountRetentions.get('error') && !byOrderEmpty) {
                innerContent = this.buildConectionError();
            } else if (byOrderEmpty) {
                hideComponent = true;
            } else {
                const headersRow = this.buildHeadersRow();
                let nextPageButton;

                if (immAccountRetentions.get('nextPage')) {
                    nextPageButton = (
                        <div className="account-retentions__more-movements">
                            <OKButton
                                modifier="link-complementary"
                                onClick={this.handleNextPage}
                            >
                                <FormattedText
                                    value="accountsRetentions-moreRetentions"
                                    format={__CONTACT_CENTER__ ? "uppercase" : undefined}
                                />
                            </OKButton>
                        </div>
                    );
                }

                innerContent = (
                    <div className="account-retentions__table">
                        <LastMovementsTable
                            groupByDate={true}
                            rowComponent={AccountRetentionsTableRow}
                            immTransactionsByOrder={immAccountRetentions.get('byOrder')}
                            immTransactionsById={immAccountRetentions.get('byId')}
                            columnsCount={!__CONTACT_CENTER__ ? 4 : 6}
                            groupHeaderClassName={'account-retentions__table-group-header'}
                            id={'account-retentions'}
                            currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                            language={language}
                        >
                            {headersRow}
                        </LastMovementsTable>
                        {nextPageButton}
                    </div>
                );
            }
        } else {
            innerContent = <LoadingSection />;
        }

        const mainClasses = classNames('account-retentions', {
            'account-retentions--hidden': !!hideComponent
        });

        const headerTitle = formatText('accountsRetentions-retentions');
        const titleBox = hideComponent ? '' : <OKBoxTitle value={headerTitle} />;

        return (
            <div className={mainClasses}>
                {titleBox}
                {innerContent}
            </div>
        );
    }
}

AccountRetentions.propTypes = {
    accountId: PropTypes.string,
    immAccountsRetentions: PropTypes.object,
    immScreen: PropTypes.object.isRequired,
    requestAccountRetentions: PropTypes.func.isRequired,
    requestNextAccountRetentionsPage: PropTypes.func.isRequired,
};

module.exports = AccountRetentions;
